import fs from "node:fs"
import path from "node:path"
import type { NextPage } from "next"
import Head from "next/head"

const Support: NextPage<{ initialHtmlContent: string }> = ({ initialHtmlContent }) => {
  return (
    <div>
      <Head>
        <title>Support & FAQ</title>
        <link href="/favicon.ico" rel="icon" />
        <style>
          {`
            html, body {
              background-color: white;
            }
            `}
        </style>
      </Head>
      <div
        dangerouslySetInnerHTML={{ __html: initialHtmlContent }}
        style={{
          backgroundColor: "white",
          padding: 24,
        }}
      />
    </div>
  )
}

export function getServerSideProps() {
  const htmlFilePath = path.resolve("./public", "support.html")
  const initialHtmlContent = fs.readFileSync(htmlFilePath, "utf8")

  return {
    props: { initialHtmlContent },
  }
}

export default Support
